import axios from "axios";
import fillFormFields from "./fill-form-fields";

export default function retrieveContactData(urlParams){
    if ("uuid" in urlParams || "email" in urlParams)
    {
        // console.log('found key on URL params: ', urlParams);

        let form = document.getElementsByClassName('pulse-form');

        if (form){
            form = form[0];

            if (form === undefined){
                return;
            }

            let action = form.action;
            let fieldKey, fieldValue;

            urlParams['only_data'] = true;

            axios.get(action, {params : urlParams}).then(function (res) {
                let contactData = res.data;

                Object.entries(contactData).forEach(contactField => {
                    [fieldKey, fieldValue] = contactField;

                    if (!(fieldKey in urlParams)){
                        urlParams[fieldKey] = fieldValue;
                    }
                });

                // console.log('data after retrieve: ', urlParams);

                fillFormFields(urlParams);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./app/Modules/FormBuilder/resources/assets/js/retrieve-contact-data.js